import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonCommunicationService } from './common-communication.service';
import * as FileSaver from 'file-saver';

@Injectable()
export class DownloadCoiService {
    public coiurl: string = environment.backend + environment.uri.downloadCOI;
    public sciCoiUrl: string;
    public downloadpolicyUrl: string =
        environment.backend + environment.uri.downloadPolicy;

    constructor(
        private http: HttpClient,
        private _ccs: CommonCommunicationService
    ) {}

    downloadCoi(policyToken): any {
        return this.http
            .get(this.coiurl, {
                headers: new HttpHeaders({
                    DigitalApiToken: policyToken,
                    'Content-Type': 'application/pdf',
                }),
                responseType: 'blob',
            })
            .pipe(
                map((res) => {
                    return new Blob([res], { type: 'application/pdf' });
                })
            );
    }
    sciDownloadCoi(requestBody: any): any {
        this.sciCoiUrl = environment.backend + environment.uri.sciDownloadCOI;
        return this.http
            .post(this.sciCoiUrl, requestBody, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                }),
                responseType: 'blob',
            })
            .pipe(
                map((res) => {
                    return new Blob([res], { type: 'application/pdf' });
                })
            );
    }

    downloadProposal(req: any): any {
        let downloadProposalurl =
            environment.backend + environment.uri.downloadProposal;
        // downloadProposalurl = downloadProposalurl.replace(':quoteProposalId', id);
        return this.http
            .post(downloadProposalurl, req, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                }),
                responseType: 'blob',
            })
            .pipe(
                map((res) => {
                    return new Blob([res], { type: 'application/pdf' });
                })
            );
    }

    downloadPolicy(requestBody: any): any {
        return this.http
            .post(this.downloadpolicyUrl, requestBody, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                }),
                responseType: 'blob',
            })
            .pipe(
                map((res) => {
                    return res;
                })
            );
    }
}
